import apiServices from '@/shared/services/api/axios'
import { IParamUpdateStatusAnnouncementById } from '@/modules/adminFQA/modules/announcement/shared/@types'

const AnnounceProviderService = {
    apiGetAnnounce(payload: any) {
        let url = 'provider/announcements'

        if (payload) {
            let index = 0
            for (const key in payload) {
                if (payload[key]) {
                    if (!index) {
                        url += `?${key}=${payload[key]}`
                    }
                    if (index) {
                        url += `&${key}=${payload[key]}`
                    }
                    index++
                }
            }
        }
        return apiServices.get(url)
    },
    apiGetAnnounceDetail(id: any) {
        return apiServices.get(`/provider/announcement/${id}`)
    },
    apiUpdateStatusAnnounce() {
        return apiServices.post(`/provider/update-status-announcements`)
    },
    apiUpdateStatusAnnounceById(payload: IParamUpdateStatusAnnouncementById) {
        return apiServices.post(
            '/provider/update-status-read-announcement',
            payload
        )
    }
}
export default AnnounceProviderService
